import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["checkboxAll", "checkbox"];

  connect() {
    this.toggleAllHandler = this.toggleAllHandler || this.toggleAll.bind(this);
    this.childChangeHandler = this.childChangeHandler || this.onChildChange.bind(this);

    if (this.hasCheckboxAllTarget) {
      this.checkboxAllTarget.addEventListener("change", this.toggleAllHandler);
    }
    this.checkboxTargets.forEach((cb) => cb.addEventListener("change", this.childChangeHandler));

    this.updateMasterState();
    this.updateSubmitButtonState();
  }

  disconnect() {
    if (this.hasCheckboxAllTarget) {
      this.checkboxAllTarget.removeEventListener("change", this.toggleAllHandler);
    }
    this.checkboxTargets.forEach((cb) => cb.removeEventListener("change", this.childChangeHandler));
  }

  toggleAll() {
    if (!this.hasCheckboxAllTarget) return;
    const checked = this.checkboxAllTarget.checked;
    this.checkboxTargets.forEach((cb) => {
      cb.checked = checked;
    });
    this.updateMasterState();
    this.updateSubmitButtonState();
  }

  onChildChange() {
    this.updateMasterState();
    this.updateSubmitButtonState();
  }

  updateMasterState() {
    if (!this.hasCheckboxAllTarget) return;
    const total = this.checkboxTargets.length;
    const checkedCount = this.checkboxTargets.filter((cb) => cb.checked).length;
    this.checkboxAllTarget.indeterminate = checkedCount > 0 && checkedCount < total;
    this.checkboxAllTarget.checked = checkedCount === total && total > 0;
  }

  updateSubmitButtonState() {
    const anyChecked = this.checkboxTargets.some((el) => el.checked);
    const submit = this.element.querySelector('[data-role="anonymize-submit"]');
    if (submit) submit.disabled = !anyChecked;
  }
}
